export enum FacingMode {
  environment = 'environment',
  user = 'user',
}

export enum CodeScannerResponseType {
  CODE_SCANNER_RESULT = 'result',
  CODE_SCANNER_MANUAL_INPUT_REQUEST = 'manualInput',
}

export interface CodeScannerDialogResponse {
  type: CodeScannerResponseType;
  value?: string;
}
